import { Navigate, RouteObject } from "react-router-dom";
import { ErrorBoundary } from "../components/ErrorBoundary";

export const useEquipmentInventoryRoutes = (): RouteObject[] => [
  {
    path: "equipment-inventory",
    errorElement: <ErrorBoundary />,
    lazy: () =>
      import(
        "../pages/inbound/inboundEquipmentInventory/EquipmentInventoryLayout"
      ),
    children: [
      { index: true, element: <Navigate to="live-inventory" replace /> },
      {
        path: "live-inventory",
        errorElement: <ErrorBoundary />,
        lazy: () =>
          import("../pages/inbound/inboundEquipmentInventory/LiveInventory"),
      },
      {
        path: "arriving",
        errorElement: <ErrorBoundary />,
      },
      {
        path: "activity",
        errorElement: <ErrorBoundary />,
      },
    ],
  },
];
